import { useCurrentSubscriptionApi } from '@aibees/shared/features/price-and-plan/api/use-current-subscription-api';
import { Nullable } from '@aibees/shared/definition';
import {
  dateCompare,
  fDateAdd,
  intervalToDuration,
} from '@aibees/shared/utils';
import { PLAN_EXPIRY_WARNING_DAYS } from '../features/global-notification-bar/components/subscription-bar/constants';
import { SubscriptionExpirationStatus as Status } from '../features/global-notification-bar/components/subscription-bar/types';

export function useSubscriptionExpiryInfo() {
  const { data, refetch, isLoading } = useCurrentSubscriptionApi();
  let status = Status.active;
  let warningText: Nullable<string> = null;
  const compare = dateCompare(
    Date.now(),
    data?.current?.currentPeriodEnd
      ? Date.parse(data?.current?.currentPeriodEnd)
      : fDateAdd(Date.now(), { years: 1 }),
    'desc'
  );
  const endDate = data?.current?.currentPeriodEnd
    ? new Date(data?.current?.currentPeriodEnd)
    : new Date();
  const remainingDuration = intervalToDuration(endDate);

  if (compare < 0) status = Status.expired;
  else if (
    (remainingDuration?.days ?? 0) <= PLAN_EXPIRY_WARNING_DAYS &&
    !data?.current?.plan?.metadata.is_free &&
    (data?.current?.cancelAtPeriodEnd || !!data?.current?.cancelAt)
  )
    status = Status.expiring;

  if (status === Status.expiring)
    warningText =
      remainingDuration?.days === 0
        ? 'Your subscription expires today.'
        : `Your subscription expires in ${remainingDuration?.days} days.`;

  return {
    status,
    remainingDuration,
    isExpiring: status === Status.expiring,
    isExpired: status === Status.expired,
    warningText,
    data,
    refetch,
    isLoading,
  };
}
